import * as Yup from 'yup';
import { UserRole } from '@models';

export function useValidationSchema() {
  return Yup.object<UserRole>().shape({
    role: Yup.string().nullable().required(),
  });
}
